<template>
  <WidgetWrapper
    :title="title"
    :full-height="true"
    v-loading="fullscreenLoading"
  >
    <hr class="mb-2 -mt-2" />
    <SimpleTable
      :title="'User'"
      :headers="headers"
      :items="items"
      :customizationPage="customizationPage"
      :options="options"
      @edit-row="edit"
      @remove-row="remove"
      @fetchData="fetchData"
    />
  </WidgetWrapper>
</template>

<script>
import SimpleTable from '@/components/dx/SimpleTable'
import formService from '@/mixins/FormService'
import formHelper from './form-helper'
import WidgetWrapper from '@/components/WidgetWrapper'

let service

export default {
  components: {
    SimpleTable,
    WidgetWrapper
  },

  mounted() {
    this.fetchData()
    service = new formService(this, formHelper)
  },
  data() {
    return {
      title: 'User - List',
      customizationPage: '/master/user/create',
      apiRemove: this.$appInfo.api.user.delete,
      fullscreenLoading: false,
      headers: [
        { type: 'string', text: 'Username', value: 'Username' },
        { type: 'string', text: 'Full Name', value: 'Fullname' },
        { type: 'string', text: 'Roles', value: 'RolesName' },
        { type: 'string', text: 'Email', value: 'Email' },
        {
          type: 'string',
          text: 'Action',
          value: 'Id',
          cellTemplate: 'commonAction',
          allowExporting: false
        }
      ],
      items: [],
      RecordsOnDuty: 0,
      options: {
        allowToAdd: true,
        allowToRefetch: true,
        allowExporting: true
      }
    }
  },
  methods: {
    edit(row) {
      var id = row.data.Id
      this.$router.push({
        name: `user-edit`,
        params: { id: id }
      })
    },
    async remove(row) {
      this.$confirm(
        'This will permanently delete this record. Continue?',
        'Are you sure',
        {
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(async () => {
          try {
            var id = row.data.Id
            await service.remove(id)

            this.fetchData()

            this.$message({
              type: 'success',
              message: 'Delete completed'
            })
          } catch (e) {
            this.$message.error(e)
            this.fullscreenLoading = false
            console.log(e)
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          })
        })
    },

    async fetchData() {
      try {
        this.fullscreenLoading = true
        const res = await this.$axios.get(
          this.$appInfo.api.user.getAllByAuthorize
        )
        this.items = res.data
        this.fullscreenLoading = false
      } catch (e) {
        this.fullscreenLoading = false
        console.log(e)
      }
    }
  }
}
</script>
